import * as angular from 'angular';

import { QueryState } from '@mode/legacy/types-app-state';

class ModalSelectQueryController implements angular.IController {
  static $inject = ['ViewService'];

  private query: QueryState;
  private readonly onDismiss: () => void;
  private readonly onClose: () => void;
  private readonly onApply: (args: { query: QueryState }) => void;

  $onInit() {}

  onCreateChart() {
    if (this.query != null) {
      this.onApply({ query: this.query });
      this.onDismiss();
    }
  }
}

export const ModalSelectQueryComponent: angular.IComponentOptions = {
  bindings: {
    queryList: '<',
    onApply: '&',
    onDismiss: '&',
    onClose: '&',
  },
  controller: ModalSelectQueryController,
  controllerAs: 'ctrl',
  template: `
  <div class="ds-grid-modal">
    <mode-legacy-dialog-header (closed)="ctrl.onDismiss()">
      Select a query to create a visualization
    </mode-legacy-dialog-header>
    <div class="ds-grid-modal-content">
      <div class="ds-grid-list-item">
        <div
            class="ds-grid-radio-group"
            ng-repeat="query in ctrl.queryList | orderBy:name"
            ng-click="ctrl.query = query"
        >
          <div class="ds-grid-radio-container">
            <input
                tabindex="0"
                type="radio"
                ng-value="query"
                name="active-query-list"
                aria-hidden="true"
                ng-model="ctrl.query"
                ng-attr-id="{{query.name + '-option'}}" />
            <span class="dot" ng-class="{'selected': ctrl.query === query}"></span>
          </div>
          <label
              ng-attr-for="{{query.name + '-option'}}"
              class="ds-grid-label"
          >
            <span class="text-capitalize">
              {{query.name}}
            </span>
          </label>
        </div>
      </div>
      <div class="ds-grid-modal-footer">
        <button class="btn btn-lg btn-secondary ds" ng-click="ctrl.onDismiss()">
          Cancel
        </button>
        <button
          ng-click="ctrl.onCreateChart()"
          ng-disabled="!ctrl.query"
          class="btn btn-lg btn-filled-primary">
          Create chart
        </button>
      </div>
    </div>
  </div>
  `,
};
